import { MainService } from './main.service';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class RootResolverService implements Resolve<any> {

  constructor(private api: ApiService, private toastr: ToastrService, private main: MainService, private router: Router) { }
  resolve(): Promise<any> {
    if (this.main.me.profile) {
      return new Promise((resolve) => {
        resolve(this.main.me);
      });
    }
    else {
      return new Promise((resolve, reject) => {
        this.api.get(`me/info`, {}).subscribe((v: any) => {
          if (this.main.me) {
            this.main.me.profile = v.data.user_data;
          }
          else {
            this.main.me = { profile: v.data.user_data };
          }
          resolve(v.data);
        },
          reject);
      });
    }

  }
}
